export default "__VITE_ASSET__aP9c0Fgb__"